import React, { useState } from "react";
import "./style.scss";

import Modal from "common/modal";
import CustomTooltip from "common/tooltip";

import roomIcon from "svg/rooms.svg";
import productIcon from "svg/products.svg";
import closeIcon from "svg/closeWhiteFill.svg";
import learnMoreIcon from "svg/learnMoreArrow.svg";
import openIcon from "svg/open.svg";
import imagePlaceholder from "svg/imagePlaceholder.svg";

const FloorMapCard = ({
  handleSelection,
  project,
  layerIndex,
  isCheckboxDisabled,
  isSiteDetails,
  removeLayerAction,
  layerObject,
  isSelectable,
  isShowMore,
  layerView,
  projectView,
  onShowMoreClick,
  isCreateQuote,
  isFloorSelected,
  onDuplicateClick,
  territoryAccess,
}) => {
  const [isShowFloormapModal, setIsShowFloormapModal] = useState(false);
  const layer = layerObject ? layerObject : project.layersInfo[layerIndex];
  const rooms = layer.rooms ? layer.rooms : [];
  const projectData = project;

  let productsObj = {};
  let totalProducts = 0;
  rooms?.map((room) => {
    room?.products?.map((product) => {
      if (productsObj[product.id]) {
        productsObj[product.id] = productsObj[product.id];
      } else {
        productsObj[product.id] = {};
        totalProducts += 1;
      }
    });
  });

  const handleFloormapModal = (isShow) => {
    if (isShow) {
      setIsShowFloormapModal(true);
    } else {
      setIsShowFloormapModal(false);
    }
  };
  return (
    <div className="floormap-card col-12 col-md-5 col-lg-4">
      {isSiteDetails && (
        <span
          className="floormap-card__remove"
          onClick={() =>
            removeLayerAction({
              type: "layer",
              data: {
                projectIndex: project.elementIndex,
                layerIndex: layerIndex,
                layerName: layer.name,
                projectName: layer.projectName ? layer.projectName : project.name,
                project,
                layer,
              },
            })
          }
        >
          <img src={closeIcon} alt="..." />
        </span>
      )}
      <div
        className={`${!layerView ? "floormap-card__heading-container" : "floormap-card__container"} align-items-center`}
      >
        {!layerView ? (
          <>
            <CustomTooltip
              placement="top"
              parentClass={`floormap-card__floor-name ${isSiteDetails ? " col-6" : " col-10"}`}
              trigger="hover"
              text={layer.name}
            >
              <span className={`floormap-card__floor-name ${isSiteDetails ? " col-6" : " col-10"}`}>{layer.name}</span>
            </CustomTooltip>
            {isSiteDetails && !projectView && (
              <CustomTooltip
                placement="top"
                parentClass="floormap-card__project-name"
                trigger="hover"
                text={layer.projectName ? layer.projectName : project.name}
              >
                <span className="floormap-card__project-name col-6">
                  {layer.projectName ? layer.projectName : project.name}
                </span>
              </CustomTooltip>
            )}
          </>
        ) : (
          <CustomTooltip
            placement="top"
            parentClass="floormap-card__project-name"
            trigger="hover"
            text={layer.projectName ? layer.projectName : project.name}
          >
            <span className="floormap-card__project-name col-6">
              {layer.projectName ? layer.projectName : project.name}
            </span>
          </CustomTooltip>
        )}
        {isSelectable && (
          <input
            type="checkbox"
            className="floormap-card__select-room-checkbox mx-0"
            onChange={(e) =>
              handleSelection(e, {
                type: "layer",
                data: { projectIndex: project.elementIndex, layerIndex: layerIndex },
              })
            }
            checked={layer.isSelected}
            disabled={isCheckboxDisabled}
          />
        )}
      </div>
      <div className="floormap-card__seperator" />
      <div className="floormap-card__body">
        <span className="open-icon" onClick={() => (layer.pictureData ? handleFloormapModal(true) : true)}>
          <img src={openIcon} alt="..." />
        </span>
        {layer.pictureData ? (
          <img src={layer.pictureData} className="floormap-card__body__image" />
        ) : (
          <div className="col-12 placeholder floormap-card__body my-0">
            <div className="col-12 d-flex justify-content-center placeholder floormap-card__body__image bg-secondary">
              <img src={imagePlaceholder} />
            </div>
          </div>
        )}
      </div>
      <div className="floormap-card__footer-container flex-row flex-wrap">
        <span className="d-flex align-items-center justify-content-between">
          <div className="col-10 d-flex align-items-center">
            <span className="col-2 room-icon">
              <img src={roomIcon} alt="room_icon" className="icon" />
            </span>
            <span>Rooms</span>
          </div>
          <div>
            <span className="count">{rooms?.length}</span>
          </div>
        </span>
        <span className="d-flex align-items-center justify-content-between">
          <div className="col-10 d-flex align-items-center">
            <span className="col-2 product-icon">
              <img src={productIcon} alt="product_icon" className="icon" />
            </span>
            <span>Products</span>
          </div>
          <div>
            <span className="count">{totalProducts}</span>
          </div>
        </span>
      </div>
      {(isShowMore || isCreateQuote) && (
        <div className="d-flex justify-content-between align-items-center">
          {isShowMore && (
            <div
              className="learn-more"
              onClick={() =>
                onShowMoreClick(
                  { ...layer, projectName: project.name, mprojectId: project.mprojectId },
                  "layer",
                  projectData,
                )
              }
            >
              <span>View/Edit</span>
            </div>
          )}
          {isCreateQuote && (
            <>
              <div></div>
              <input
                type="checkbox"
                className="floormap-card__select-room-checkbox mb-2"
                onChange={(e) =>
                  handleSelection(e, {
                    type: "layer",
                    data: { layer: { ...layer, projectName: project.name, mprojectId: project.mprojectId }, project },
                  })
                }
                checked={isFloorSelected}
              />
            </>
          )}
          {!isCreateQuote && (projectView || layerView) && territoryAccess && (
            <div
              className="learn-more"
              onClick={() =>
                onDuplicateClick({
                  ...layer,
                  projectName: project.name,
                  mprojectId: project.mprojectId,
                  floorPlanNotes: project.floorPlanNotes,
                  specialInstructions: project.specialInstructions,
                  installerNotes: project.installerNotes,
                })
              }
            >
              <span>Duplicate</span>
            </div>
          )}
        </div>
      )}
      {isShowFloormapModal && (
        <Modal
          title={layer.name}
          handleSave={() => {}}
          handleCancel={() => handleFloormapModal(false)}
          size={"lg"}
          sectionName={""}
          bodyClass={"account-lookup-search-form"}
        >
          <>
            <img src={layer.pictureData} alt="..." className="col-12 px-1 px-md-2" />
          </>
        </Modal>
      )}
    </div>
  );
};

export default FloorMapCard;
